import apiClient from "./axios"

export const getAccountExpenses = async (params = {}) => {
  const { data } = await apiClient.get("/account-expenses", { params })
  return data
}

export const getAccountExpense = async id => {
  const { data } = await apiClient.get(`/account-expenses/${id}`)
  return data
}

export const createAccountExpense = async payload => {
  const { data } = await apiClient.post("/account-expenses", payload)
  return data
}

export const updateAccountExpense = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/account-expenses/${id}`, payload)
  return data
}

export const deleteAccountExpense = async id => {
  const { data } = await apiClient.delete(`/account-expenses/${id}`)
  return data
}

export const approveAccountExpense = async id => {
  const { data } = await apiClient.post(`/account-expenses/${id}/approve`)
  return data
}

export const rejectAccountExpense = async ({ id, rejection_reason }) => {
  const { data } = await apiClient.post(`/account-expenses/${id}/reject`, { rejection_reason })
  return data
}
